// test2526
(2526 && 0);
